$(function() {
  "use strict";

  var $fullpage_container = $(".body-content.scroll-type-locked");

  if($fullpage_container.length > 0) {
    
    var anchors = typeof window._90dl_page_section_anchors != 'undefined' ? window._90dl_page_section_anchors : [];

    var fullpage_options = {
        //Navigation
        menu: '#single_page_menu',
        //lockAnchors: true,
        anchors: anchors,
        slidesNavigation: false,

        //Scrolling
        css3: true,
        scrollingSpeed: 600,
        autoScrolling: true,
        fitToSection: true,
        fitToSectionDelay: 50,
        navigation: true,
        //easing: 'easeInOutQuad',
        //easingcss3: 'ease-in-out',
        scrollBar: false,

        //Design
        controlArrows: true,
        verticalCentered: true, // we set this to true, so we get the plugins wrapping around our content, then we control vertical alignment with our own class
        paddingTop: false, // we disable to control ourselves
        paddingBottom: false, // we disable to control ourselves
        fixedElements: '#site-header',
        responsiveWidth: 645,
        //responsiveHeight: 0,
        //responsiveSlides: false,

        //Custom selectors
        sectionSelector: '.page-section',
        slideSelector: '.page-section-slide',

        afterLoad: function(anchorLink, index){
          if(anchorLink == 'hobs-group-home') {
            setTimeout(function(){
              $('.loader').hide();
              $('.hobs-home').show();
              Foundation.reInit('equalizer');
            }, 1300);
           
          }
        },

        afterSlideLoad: function( anchorLink, index, slideAnchor, slideIndex){
          var $current_slide = $(this);

          var $slide_navigation = $(".page-section[data-anchor='" + anchorLink + "'] .page-section-slide-navigation");

          if($slide_navigation.length) {
            $slide_navigation.find("[data-target-section]").removeClass("active");
            $slide_navigation.find("[data-target-section='" + index + "'][data-target-slide='" + slideIndex + "']").addClass("active");
          }
        }
    };
    $fullpage_container.fullpage(fullpage_options);   
    
    // Slide Navigation Links
    $("[data-target-slide]").each(function() {
      var $trigger = $(this);
      var $target_section = $trigger.data("target-section");
      var $target_slide = $trigger.data("target-slide");
      
      if(typeof $target_section === 'undefined' || $target_section === "") {
        return;
      }

      $target_section = parseInt($target_section);
      $target_slide = typeof $target_slide === 'undefined' ? 0 : parseInt($target_slide);
      

      $trigger.on("click", function(e) {
        e.preventDefault();
        console.log($target_section, $target_slide);
        $.fn.fullpage.moveTo($target_section, $target_slide);
      });
    });

  }

});